import { AZURE_ENTRA_CLIENT_ID, WEB_AUTH_URL } from "./paths.config";

export const msalConfig = {
    auth: {
      clientId: AZURE_ENTRA_CLIENT_ID,
      authority: "https://login.microsoftonline.com/25bb31ce-ddda-4699-ae62-62c9fd802799",
      redirectUri: WEB_AUTH_URL
    },
    cache: {
      cacheLocation: "sessionStorage",
      storeAuthStateInCookie: false,
    }
  };
export const loginRequest = {
    //scopes: ["User.Read", "Profile"],
    scopes: [
      `api://${AZURE_ENTRA_CLIENT_ID}/SG3PlusAAD_SCOPE_access_as_user`
    ],
    prompt: "select_account"
};

//Crear pagina que se usará de redireccion.
//En load obtener las propiedades del usuario.
//Crear endpoint para recibir datos de AAD.
//Validar que el usuario exista.
//Si no existe crearlo, habilitarlo, hacer login y redireccionar a donde se deba.
//Si existe, hacer login y redireccionar a donde se deba.
//Dependiendo de la respuesta. Redireccionar a perfil o mostrar mensaje de error.